@if (loaderService.loading$ | async) {
  <spinner class="absolute z-40 w-[100vw] h-[100vh] bg-[var(--bg-modal)]"></spinner>
}
<app-notification class="absolute z-30"></app-notification>
<app-modal class="absolute z-20"></app-modal>

@if (showUpdateBanner()) {
  <div
    class="fixed bottom-5 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 rounded-lg px-5 py-2.5 shadow-xl border border-[var(--accent-warning)] bg-[var(--bg-warning)] whitespace-nowrap"
  >
    <span class="w-2 h-2 rounded-lg bg-[var(--accent-warning)] animate-pulse shrink-0"></span>
    <span class="text-sm text-[var(--secondary-color)]">A new version is available</span>
    <button
      (click)="applyUpdate()"
      class="text-sm font-semibold text-[var(--accent-warning)] hover:opacity-75 transition-opacity cursor-pointer"
    >
      Update now
    </button>
    <span class="text-[var(--secondary-color)] select-none">·</span>
    <button
      (click)="dismissUpdate()"
      class="text-sm text-[var(--secondary-color)] hover:opacity-75 transition-opacity cursor-pointer"
    >
      Later
    </button>
  </div>
}

@if (showHeader) {
  <app-header class="z-10 absolute w-full"></app-header>
}

<div class="flex h-full" [ngClass]="{ 'pt-[61px]': showHeader }">
  @if (isAdmin() && !isPreviewMode()) {
    <side-bar class="h-[100%]"></side-bar>
  }

  <div class="size-full flex flex-col">
    @if (loggedIn() && !storage.userInfo()) {
      <div class="size-full overflow-x-hidden bg-[var(--background-primary-color)]"></div>
    } @else {
      <main
        #mainContent
        class="size-full bg-[var(--background-primary-color)] text-[var(--text-primary)] flex flex-col overflow-y-auto overflow-x-hidden z-0"
        [ngClass]="{ 'h-[100vh]': true, 'px-7 pt-5 pb-5': loggedIn() && isAdmin() && !isPreviewMode() }"
      >
        <router-outlet></router-outlet>
      </main>
    }

    @if (isAdmin() && !isPreviewMode()) {
      <app-footer></app-footer>
    }
  </div>
</div>
